import { makeStyles } from '@material-ui/core';
import * as color from 'Material-UI/colors';

const useStyles = makeStyles({
  policyNumber: {
    color: color.sanlamAccentGrey,
  },
  subscriber: {
    fontWeight: 'bold',
  },
});

export default useStyles;
